module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._v("\n  By "), _c('a', {
    attrs: {
      "href": "https://suoheikki.com/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n    Sami Suo-Heikki\n    "), _c('svg', {
    attrs: {
      "fill": "#66BB6A",
      "height": "12",
      "viewBox": "0 0 24 24",
      "width": "12",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
    }
  })])]), _vm._v("\n  and\n  "), _c('a', {
    attrs: {
      "href": "https://github.com/samiheikki/javascript-guessing-game/graphs/contributors",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n    Contributors\n    "), _c('svg', {
    attrs: {
      "fill": "#66BB6A",
      "height": "12",
      "viewBox": "0 0 24 24",
      "width": "12",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64698a2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Credits.vue
// module id = 146
// module chunks = 1